import React, { useEffect } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import Logo from '../Images/Logo.webp';
import { Alert, AlertTitle } from '@material-ui/lab'
import { Button } from '@material-ui/core';
import { Helmet } from 'react-helmet';

function NotAuthorized() {
    const history = useHistory();

    useEffect(() => {
        history.push('/notAuthorized');
    }, []);

    const handleClick = () => {
        history.push('/');
    };

    return (
        <>
            <div className="container-fluid emailAlert">
                <Helmet>
                    <meta name="description" content="Not Authorized" />
                    <title>Not Authorized | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row mt-2">
                            <div className="col-md-12 mt-3">
                                <Alert severity="error">
                                    <AlertTitle>Not Authorized!</AlertTitle>
                                    You are not authorized or logged in to view this page, please logged in your account and try again.<br /><br />
                                    <Button variant="contained" className="registerEmp__btnLogin"
                                        onClick={handleClick}>Click here to login</Button>
                                </Alert>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotAuthorized
